import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Modal, Paragraph, Popover } from '@treams/treams-ui';

type Props = {
	onRestart: () => void;
	disabled?: boolean;
};

/**
 * Restart clears the transcript and summary, so it asks first.
 * @param root0 The button props.
 * @param root0.onRestart Clears the transcript and starts recording again.
 * @param root0.disabled Disables the button while a recording action is in progress.
 */
export function RestartTranscriptionButton({ onRestart, disabled }: Props) {
	const { t } = useTranslation();
	const [confirming, setConfirming] = useState(false);

	return (
		<>
			<Button
				title={t('transcription.streaming.restart')}
				type="ai"
				small
				disabled={disabled}
				onClick={() => setConfirming(true)}
			/>
			<Popover center visible={confirming}>
				<Modal>
					<Modal.Header title={t('common.areYouSure')} onClose={() => setConfirming(false)} />
					<Modal.Contents>
						<Paragraph>{t('transcription.streaming.restartConfirm')}</Paragraph>
					</Modal.Contents>
					<Modal.FormFooter
						onCancel={() => setConfirming(false)}
						onSave={() => {
							setConfirming(false);
							onRestart();
						}}
						saveTitle={t('transcription.streaming.restart')}
					/>
				</Modal>
			</Popover>
		</>
	);
}
